import {createFeatureSelector, createSelector} from "@ngrx/store";
import {dashboardCaseFilesFeatureKey, DashboardCaseFilesState} from "../reducers/dashboard.reducer";

const dashboardCaseFilesFeatureState = createFeatureSelector<DashboardCaseFilesState>(dashboardCaseFilesFeatureKey);

export const getIncomingDashCaseFiles = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.incomingDashCaseFiles ?? []
);

export const getIncomingDashPageData = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.incomingPagedResponse ?? null
);

export const getOutgoingDashCaseFiles = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.outgoingDashCaseFiles ?? []
);

export const getOutgoingDashPageData = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.outgoingPagedResponse ?? null
);

export const getArchivedDashCaseFiles = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.archivedCaseFiles ?? []
);

export const getArchivedDashPageData = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.archivedPagedResponse ?? null
);

export const getActiveDashCaseFiles = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.activeCaseFiles ?? []
);

export const getActiveDashPageData = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.activePagedResponse ?? null
);

export const getClosedDashCaseFiles = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.closedCaseFiles ?? []
);

export const getClosedDashPageData = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.closedPagedResponse ?? null
);

export const getRegionCases = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.regionCases ?? []
)

export const getRegionReport = createSelector(
  dashboardCaseFilesFeatureState,
  state => state.regionReport ?? []
);
